import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {mealsService} from "../../../services/settings-services";


const initialState = {
    mealsArray: [],
    status: null,
    error: null,
    trigger: 0,
}

const getAllMeals = createAsyncThunk(
    'mealsSlice/getAllMeals',
    async (_, {rejectWithValue}) => {
        try {
            return await mealsService.getAll();
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);


const mealsSlice = createSlice({
    name: "meals",
    initialState,
    reducers: {
        changeTrigger: (state, action) => {
            state.trigger = state.trigger + 1;
        },
    },
    extraReducers: builder =>
        builder
            .addCase(getAllMeals.pending, state => {
                state.status = 'Loading';
                state.error = null;
            })
            .addCase(getAllMeals.fulfilled, (state, action) => {
                state.status = 'fulfilled';
                state.mealsArray = action.payload;
            })
            .addCase(getAllMeals.rejected, (state, action) => {
                state.status = 'rejected';
                state.error = action.payload;
            })
});

const {reducer: mealsReducer, actions} = mealsSlice;
const mealsActions = {
    ...actions,
    getAllMeals
}

export {
    mealsReducer,
    mealsActions
}